<div class="kavalli-search">
   <input type="text" [placeholder]="placeholder" (keyup)="changeSearch.emit($event)" />
   <span class="icon-search"></span>
</div>
